import { ActiveSliceType, DriftSliceType, SliceGroup, SliceInvestor } from "store/types";

export interface ResolvedSlice {
  sliceId: number;
  sliceType: "investors" | "slices";
}

// Resolve the active selection (investor or group) to the API's slice id +
// collection name. Returns null when there is no usable selection.
export const resolveSlice = (
  activeSliceType: ActiveSliceType | null,
  selectedInvestorId: SliceInvestor["id"] | null,
  selectedGroupId: SliceGroup["id"] | null
): ResolvedSlice | null => {
  if (activeSliceType === "investor" && selectedInvestorId !== null) {
    return { sliceId: Number(selectedInvestorId), sliceType: "investors" };
  }
  if (activeSliceType === "group" && selectedGroupId !== null) {
    return { sliceId: Number(selectedGroupId), sliceType: "slices" };
  }
  return null;
};

// The display-mode endpoint names the same selection differently:
// an investor is an "entity", a saved group is a "slice".
const DRIFT_SLICE_TYPE: Record<ResolvedSlice["sliceType"], DriftSliceType> = {
  investors: "entity",
  slices: "slice"
};

export const resolveDriftSlice = (
  activeSliceType: ActiveSliceType | null,
  selectedInvestorId: SliceInvestor["id"] | null,
  selectedGroupId: SliceGroup["id"] | null
): { sliceId: number; sliceType: DriftSliceType } | null => {
  const slice = resolveSlice(activeSliceType, selectedInvestorId, selectedGroupId);
  return slice ? { sliceId: slice.sliceId, sliceType: DRIFT_SLICE_TYPE[slice.sliceType] } : null;
};
